import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { pathOr } from 'ramda'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    Box: {
      padding: '0 20px',
    },
    username: {
      flex: 1,
      margin: '10px 0px',
    },
    usernameContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    lockContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    lockStatusTxt: {
      marginLeft: 10,
    },
    btnRow: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    btnContainer: {
      backgroundColor: '#FFF',
      boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.05)',
      borderRadius: '3px',
      margin: '20px 0px',
    },
    actionBtn: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
    },
    buttonFooterContainer: {
      padding: '10px 20px',
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#FFF',
      display: 'flex',
      justifyContent: 'flex-end',
      borderTop: '1px solid #EEE',
      zIndex: 1
    },
    footerBtn: {
      margin: '0px 10px',
    },
    borrowInfoTitle: {
      marginBottom: 20,
      marginTop: 20,
    },
    cardTitle: {
      flex: 1,
    },
    cardTitleContainer: {
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: `${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
    },
    switchLabel: {
      fontWeight: 200,
      fontFamily: 'Open Sans',
      fontSize: 14,
      display: 'flex',
      flexDirection: 'row',
      marginRight: 20,
      marginTop: '5px',
      marginBottom: '8px',
      [theme.breakpoints?.down('md')]: {
        maxWidth: 'calc(100% - 94px)',
      },
    },
    title: {
      color: pathOr('', ['palette', 'basic', 'steel'], theme),
      fontWeight: 600,
      fontFamily: 'Open Sans',
      [theme.breakpoints?.down('sm')]: {
        fontSize: 14,
      },
      marginBottom: 16
    },
    messageBarWarning: {
      marginBottom: 10,
      marginTop: 10,
      backgroundColor: `${pathOr('', ['palette', 'warning', 'main'], theme)}`,
    },
    messageBarSuccess: {
      marginBottom: 20,
      marginTop: 20,
      backgroundColor: `${pathOr('', ['palette', 'success', 'main'], theme)}`,
    },
    messageBarError: {
      marginBottom: 20,
      marginTop: 20,
      backgroundColor: `${pathOr('', ['palette', 'error', 'main'], theme)}`,
    },
    cardContainerLeft: {
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      borderRight: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      borderRadius: '0px 0px 0px 5px',
    },
    cardContainerRight: {
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      borderLeft: `none`,
      borderRadius: '0px 0px 5px 0px',
      [theme.breakpoints?.down('md')]: {
        borderLeft: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      }

    },
    cardTitleContainerLeft: {
      borderRadius: '5px 0px 0px 0px',
    },
    cardTitleContainerRight: {
      borderRadius: '0px 5px 0px 0px',
    },
    cardTitleContainerMiddle: {
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: `${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
    },
    checkbox: {
      padding: 0,
      margin: '0px 10px',
    },
    checkboxInput: {
      padding: 0,
      marginRight: 10,
    },
    checkBoxContainer: {
      marginRight: 10,
    },
    checkBoxVertContainer: {
      flex: 1,
      marginBottom: 8,
    },
    inputLabel: {
      color: '#39444E',
    },
    inputBox: {
      marginTop: 6,
      marginBottom: 8,
      borderColor: pathOr('', ['palette', 'gray', 'darkGray'], theme),
      '& MuiSelect-icon': {
        color: `${pathOr('', ['palette', 'gray', 'softGray'], theme)} !important`,
      },
      '& fieldset': {
        borderColor: `${pathOr('', ['palette', 'gray', 'lightGray'], theme)} !important`,
      },
    },
    dropdownArrow: {
      color: `${pathOr('', ['palette', 'gray', 'softGray'], theme)} !important`,
    },
    parentCheckbox: {
      marginBottom: '10px',
      borderRadius: '6px',
    },
    selectBox: {
      height: 'fit-content',
      marginTop: 8
    },
    sectionTitle: {
      flex: 1,
      marginTop: 30,
      marginBottom: 10,
    },
    sectionSmallTitle: {
      marginBottom: 10,
      marginRight: 10,
    },
    typeOfCredit: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 10,
    },
    twoRowContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    firstRow: {
      flex: 1,
      marginRight: 20,
    },

    secondRow: {
      flex: 1,
    },
    divider: {
      marginTop: 20,
      marginBottom: 30,
    },
    dividerInvisible: {
      marginTop: 5,
      color: 'transparent',
      border: 'none'
    },
    langContainer: {
      display: 'flex',
    },
    langBox: {
      flex: 1,
    },
    dialogDescription: {
      textAlign: 'center',
      maxWidth: 540,
      margin: '0px auto',
      marginBottom: 40,
    },
    btnActionContainer: {
      borderTop: '1px solid #EEE',
      padding: 20,
    },
    goBackBtn: {
      top: 16,
      left: 10,
      position: 'absolute',
    },
    dialogTitle: {
      textAlign: 'center',
      fontFamily: 'Martel,serif',
    },
    addressHead: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 10,
    },
    tabPanel: {
      width: '100%'
    },
    tabList: {
      background: pathOr('', ['palette', 'gray', 'lightGray'], theme),
      border: '1px solid',
      borderColor: pathOr('', ['palette', 'gray', 'lightGray'], theme),
      borderRadius: '6px',
      display: 'flex',
      alignItems: 'center',
      maxHeight: '50px',
      width: 'fit-content',
      [theme.breakpoints?.down('md')]: {
        marginBottom: '16px',
      },
    },
    tab: {
      color: pathOr('', ['palette', 'gray', 'extraDarkGray'], theme),
      fontWeight: 600,
      fontSize: '14px',
      fontFamily: 'Open Sans',
      '&.Mui-selected': {
        color: pathOr('', ['palette', 'primaryColor'], theme),
        background: pathOr('', ['palette', 'basic', 'white'], theme),
        borderRight: `1px solid ${pathOr('', ['palette', 'basic', 'white'], theme)}`,
        borderLeft: `1px solid ${pathOr('', ['palette', 'basic', 'white'], theme)}`,
        borderRadius: '6px'
      },
    },
    select: {
      padding: 10,
    },
    contentItem: {
      paddingLeft: 0,
      width: '13%',
    },
    applyBox: {
      marginTop: '-30px',
    },
    card: {
      marginBottom: 20,
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      borderRadius: '0px 0px 5px 5px',
      boxShadow: 'none'
    },
    cardTitleContainerGrid: {
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: `${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)}`,
      borderBottom: 'none',
      borderRadius: '5px 5px 0px 0px',
      columnGap: '16px'
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: "repeat(2, 1fr)",
      columnGap: '16px'
    },
    cardContainer: {
      border: `1px solid ${pathOr('', ['palette', 'gray', 'extraLightGray'], theme)} !important`,
      borderRadius: '0px 0px 5px 5px !important',
    },
    tableHeadCell: {
      color: `${pathOr('', ['palette', 'gray', 'extraDarkGray'], theme)} !important`,
      fontWeight: `600 !important`
    },
    tableCell: {
      color: `${pathOr('', ['palette', 'gray', 'gray'], theme)} !important`,
    },
    checkBoxLabel: {
      fontFamily: 'Open sans',
      fontSize: 16,
      fontWeight: 600,
      color: `${pathOr('', ['palette', 'gray', 'extraDarkGray'], theme)} !important`,
    },
    tabsRoot: {
      '& .Mui-selected': {
        color: '#000 !important',
      },
      '& .MuiButtonBase-root': {
        fontWeight: 'bold',
        color: `${pathOr('', ['palette', 'basic', 'softGrey'], theme)}`,
      },
    },
    tabsIndicator: {
      height: 3,
    },
    tabs: {
      display: 'flex',
    },

    menuIconCount: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      width: 24,
      height: 24,
      marginLeft: '15px',
      marginTop: -3,
      backgroundColor: `${pathOr('', ['palette', 'primaryColor'], theme)}`,
      color: `${pathOr('', ['palette', 'mainLight'], theme)}`,
      fontWeight: 600,
      fontSize: 11,
      lineHeight: '24px',
      fontFamily: 'Open Sans',
    },
    buttonConatinerGrid: {
      width: '100%'
    },
    headerWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    dataDialogTitle: {
      textAlign: 'center',
      fontFamily: 'Martel,serif',
      [theme.breakpoints?.down('md')]: {
        marginTop: '45px',
      },
    },
  })
);

const useConatinerStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minWidth: 'calc(100vw - 250px)!important',
      [theme.breakpoints.down('md')]: {
        minWidth: '100vw !important',
      },
    },
  })
);

export { useStyles, useConatinerStyles };
